// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.1145 21.8111C10.7214 22.3105 11.3529 22.7684 12 23.2136C12.6472 22.7686 13.2782 22.3109 13.8854 21.8112C14.6614 21.1727 15.6981 20.2496 16.738 19.1123C18.7821 16.8765 21 13.6373 21 10C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10C3 13.637 5.2179 16.8762 7.26196 19.112C8.30183 20.2494 9.33859 21.1725 10.1145 21.8111ZM16 9.5V11.5H8V9.5H16Z"}}]};

const LocationReductionFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'location-reduction-filled',
    ref,
    icon: element,
  },
));

LocationReductionFilledIcon.displayName = 'LocationReductionFilledIcon';

export default LocationReductionFilledIcon;
